import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import ImmutablePropTypes from 'react-immutable-proptypes';
import IconMixin from '../mixins/IconMixin';
import {SIZE_LARGE} from '../mixins/IconMixin';

export default createReactClass({
  propTypes: {
    icons: ImmutablePropTypes.orderedSet.isRequired,
    hasLoaded: PropTypes.bool.isRequired,
    highlightedIconNames: ImmutablePropTypes.map.isRequired,
  },

  mixins: [IconMixin, ImmutableRenderMixin],

  render() {
    const {icons, hasLoaded, highlightedIconNames} = this.props;
    const iconElements = this.renderIcons(icons, SIZE_LARGE, {addIconSetName: true, highlightedIconNames, rowCount: 8});
    const label = (hasLoaded) ? `${icons.size} matching icons` : 'Searching…';

    return (
      <div className="icon-set-preview-lg">
        <div className="text-muted">{label}</div>
        <hr />
        <div className="icons">
          {iconElements}
        </div>
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/IconSearchResults.js